class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
    this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
    this.cartOverlay = this.querySelector(".m-cart__overlay");
    this.rootUrl = window.Shopify.routes.root;

    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", (event) => {
      if (
        event.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner
      ) {
        this.close();
      }
    });

    // Add event delegation for remove buttons
    this.addEventListener("click", (event) => {
      const removeButton = event.target.closest(".m-cart-item__remove");
      if (removeButton) {
        event.preventDefault();
        const cartItem = removeButton.closest("[data-cart-item]");
        if (cartItem) {
          const itemKey =
            cartItem.dataset.key ||
            cartItem.querySelector("[name='updates[]']").dataset.key;
          this.removeItem(itemKey);
        }
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        if (MinimogSettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add("m-cart-drawer--active");
    requestAnimationFrame(() => {
      this.style.setProperty("--m-bg-opacity", "0.5");
      this.cartDrawerInner.style.setProperty("--translate-x", "0");
    });
    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    document.documentElement.classList.add("prevent-scroll");

    // Ensure upsell slider positions are correct on open
    setTimeout(() => {
      const $slider = window.jQuery && window.jQuery(".cart-upsell-slider");
      if ($slider && $slider.length && typeof $slider.slick === "function") {
        $slider.slick("setPosition");
      }
    }, 50);
  }

  close() {
    this.style.setProperty("--m-bg-opacity", "0");
    this.cartDrawerInner.style.setProperty("--translate-x", "100%");
    setTimeout(() => {
      this.classList.remove("m-cart-drawer--active");
      document.documentElement.classList.remove("prevent-scroll");
    }, 300);
  }

  renderContents(parsedState) {
    console.log("Received parsedState:", parsedState);

    // If response is HTML content (from cart-drawer section)
    if (
      typeof parsedState === "string" &&
      parsedState.includes("m-cart-drawer")
    ) {
      const tempContainer = document.createElement("div");
      tempContainer.innerHTML = parsedState;

      // Find and update cart items
      const cartItems = tempContainer.querySelector(
        "[data-minimog-cart-items]"
      );
      if (cartItems) {
        const currentCartItems = this.querySelector(
          "[data-minimog-cart-items]"
        );
        if (currentCartItems) {
          currentCartItems.innerHTML = cartItems.innerHTML;
        }
      }

      // Update other sections
      [
        "[data-minimog-cart-discounts]",
        "[data-cart-subtotal]",
        "[data-minimog-gift-wrapping]",
      ].forEach((selector) => {
        const newSection = tempContainer.querySelector(selector);
        const currentSection = this.querySelector(selector);
        if (newSection && currentSection) {
          currentSection.innerHTML = newSection.innerHTML;
        }
      });

      setTimeout(() => {
        this.open();
      });
      return;
    }

    // Handle single item response (from add to cart)
    if (parsedState && parsedState.variant_id) {
      // Fetch and render cart drawer section
      fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const tempContainer = document.createElement("div");
          tempContainer.innerHTML = responseText;

          this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);

            if (!sectionElement) {
              console.warn(
                `Section element not found: ${section.selector || section.id}`
              );
              return;
            }

            const newContent = tempContainer.querySelector(section.selector);
            if (newContent) {
              sectionElement.innerHTML = newContent.innerHTML;
            }
          });

          setTimeout(() => {
            this.open();
          });
          // Ensure drawer empty state is synced after adding item
          this.getCart().then((cart) => {
            this.classList.toggle("m-cart--empty", cart.item_count === 0);
            this.updateCartCount(cart.item_count);
          });
        })
        .catch((error) => {
          console.error("Error fetching cart drawer content:", error);
        });

      return;
    }

    // Handle cart.js JSON response
    if (parsedState && parsedState.items) {
      // Update cart count
      const itemCount = parsedState.items.length;
      this.updateCartCount(itemCount);

      // Fetch and render cart drawer section
      fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const tempContainer = document.createElement("div");
          tempContainer.innerHTML = responseText;

          this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);

            if (!sectionElement) {
              console.warn(
                `Section element not found: ${section.selector || section.id}`
              );
              return;
            }

            const newContent = tempContainer.querySelector(section.selector);
            if (newContent) {
              sectionElement.innerHTML = newContent.innerHTML;
            }
          });

          setTimeout(() => {
            this.open();
          });
          // Sync empty state and cart count after items update
          this.getCart().then((cart) => {
            this.classList.toggle("m-cart--empty", cart.item_count === 0);
            this.updateCartCount(cart.item_count);
          });
        })
        .catch((error) => {
          console.error("Error fetching cart drawer content:", error);
        });

      return;
    }

    console.warn("Invalid parsedState received in renderContents");
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.getSectionsToRender().forEach((section) => {
          if (section.block === "cart-items") {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(
              responseText,
              section.selector
            );
          } else {
            if (updateFooter) {
              const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(
                responseText,
                section.selector
              );
            }
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
    this.getCart().then((cart) => {
      this.classList.toggle("m-cart--empty", cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-items]",
        block: "cart-items",
      },
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: "[data-cart-subtotal]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
        block: "cart-footer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Add new removeItem method
  removeItem(key) {
    fetch(`${this.rootUrl}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        if (cart.item_count === 0) {
          this.classList.add("m-cart--empty");
        }

        // Update cart count
        this.updateCartCount(cart.item_count);

        // Fetch and update cart drawer content
        fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const tempContainer = document.createElement("div");
            tempContainer.innerHTML = responseText;

            this.getSectionsToRender().forEach((section) => {
              const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);

              if (!sectionElement) {
                console.warn(
                  `Section element not found: ${section.selector || section.id}`
                );
                return;
              }

              const newContent = tempContainer.querySelector(section.selector);
              if (newContent) {
                sectionElement.innerHTML = newContent.innerHTML;
              }
            });
          })
          .catch((error) => {
            console.error("Error updating cart drawer:", error);
          });
      })
      .catch((error) => {
        console.error("Error removing item from cart:", error);
      });
  }
}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
      },
    ];
  }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);
